// @flow
import * as React from 'react';
import StringUtil from '../util/StringUtil';

type Props = {
  text: string,
  pattern: string
};

function escapeRegExp(string) {
  return string.replace(/([.*+?^${}()[\]\\])/g, '\\$1');
}
export default class HighlightText extends React.Component<Props, {}> {
  render() {
    const { text, pattern } = this.props;
    const patterns = pattern.trim().replace(/\s+/g, '|');
    const patternRegx = new RegExp(`(${escapeRegExp(patterns)})`, 'ig');
    const textArray: Array<string> = text || text === 0 ? text.toString().split(patternRegx) : [];
    const results = textArray.map(
      (result, i) => (result.match(patternRegx) ? <b key={i}>{result}</b> : <span key={i}>{result}</span>)
    );
    return <span name="HighlightText">{results}</span>;
  }
}
